var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-agency-cost-plot',{staticClass:"mb-3",style:(_vm.style),attrs:{"chart-data":_vm.chartData}})}
var staticRenderFns = []

export { render, staticRenderFns }